import create from "zustand";

export const currentTab = create((set) => ({
  current: null,
  switchTab: (newTab) => set({ current: newTab }),
}));

// export const allTabs = create((set) => ({
//     tabs: ["News", "Opinions", "Horse", "Syndicate"],
//     setTabs: (newTabs) => set((state) => ({ tabs: newTabs })),
// }))
  